import { SearchQuery } from "shared/data/reducers/types/storage";
import FlightOffer from "shared/types/flightOffer";

const filterTransfers = (searchQuery: SearchQuery) => (
  flightOffer: FlightOffer
) => {
  if (
    searchQuery.airports_transfers &&
    searchQuery.airports_transfers !== "all"
  ) {
    const aTransfersInThisFlight = flightOffer.FlightItinerary.FlightStream[0][0].FlightSegments.FlightSegment.filter(
      (_oFlightSegment, index) => {
        return (
          index !==
          flightOffer.FlightItinerary.FlightStream[0][0].FlightSegments
            .FlightSegment.length -
            1
        );
      }
    ).map((oFlightSegment) => oFlightSegment.DestinationAirport);

    if (!aTransfersInThisFlight.includes(searchQuery.airports_transfers)) {
      return false;
    }
  }

  return true;
};

export default filterTransfers;
